import React from 'react';
import { Badge, Tooltip, Typography } from '@mui/material';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';

// Motion-enhanced wrapper
const FrostedWrapper = styled(motion.div)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(224, 247, 250, 0.15);
  border: 1px solid rgba(178, 235, 242, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 6px 30px rgba(0, 124, 145, 0.3);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;

  &:hover {
    box-shadow: 0 8px 40px rgba(2, 136, 209, 0.25);
    transform: translateY(-1px);
  }
`;

// Snowflake with motion hover
const Snowflake = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00bcd4;
`;

const CountBadge = styled.div`
  background: #0288d1;
  color: white;
  font-size: 0.75rem;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(2, 136, 209, 0.4);
  position: absolute;
  top: -10px;
  right: -10px;
`;

interface FrozenOrdersButtonProps {
  count: number;
  onClick: () => void;
}
const FrozenOrdersButton = ({
  count = 0,
  onClick,
}: FrozenOrdersButtonProps) => {
  return (
    <Tooltip title="Frozen Orders">
      <FrostedWrapper
        onClick={onClick}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <Snowflake
          whileHover={{
            rotate: [0, 15, -15, 0],
            transition: { duration: 0.6 },
          }}
        >
          <AcUnitIcon fontSize="medium" />
        </Snowflake>

        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '1rem',
            color: '#01579b',
          }}
        >
          Frozen Orders
        </Typography>

        {count > 0 && <CountBadge>{count}</CountBadge>}
      </FrostedWrapper>
    </Tooltip>
  );
};

export default FrozenOrdersButton;
